"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContext = exports.useCalendarContext = exports.pickContext = exports.default = exports.contextKeys = exports.DefaultContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _en_us = require("./locale/en_us");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var DefaultContext = {
  locale: {
    months: _en_us.months,
    weekdays: _en_us.weekdays
  },
  prefixCls: 'zr-cal',
  components: {},
  monthBeforeYear: true,
  onlyValidYear: true,
  onlyValidDecade: true,
  onChangeWhenPrevNextClick: true,
  disabledPrevNextClickWhenDisabled: true
};
exports.DefaultContext = DefaultContext;
var contextKeys = Object.keys(DefaultContext);
exports.contextKeys = contextKeys;
var CalendarContext = /*#__PURE__*/(0, _react.createContext)(DefaultContext);
var _default = CalendarContext;
exports.default = _default;

var pickContext = function pickContext(obj) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var rest = _objectSpread({}, obj);

  var context = {};
  contextKeys.forEach(function (key) {
    if (key in rest) {
      context[key] = rest[key];
      delete rest[key];
    }
  });
  return [context, rest];
};

exports.pickContext = pickContext;

var useCalendarContext = function useCalendarContext(props) {
  var _pickContext = pickContext(props),
      _pickContext2 = (0, _slicedToArray2.default)(_pickContext, 2),
      context = _pickContext2[0],
      rest = _pickContext2[1];

  var inheritContext = (0, _react.useContext)(CalendarContext);
  var finalContext = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread(_objectSpread({}, DefaultContext), inheritContext), context);
  }, [context, inheritContext]);
  return [finalContext, rest];
};

exports.useCalendarContext = useCalendarContext;

var withContext = function withContext(Component) {
  var ComponentWithContext = function ComponentWithContext(props) {
    var _useCalendarContext = useCalendarContext(props),
        _useCalendarContext2 = (0, _slicedToArray2.default)(_useCalendarContext, 2),
        finalContext = _useCalendarContext2[0],
        rest = _useCalendarContext2[1];

    return /*#__PURE__*/_react.default.createElement(CalendarContext.Provider, {
      value: finalContext
    }, /*#__PURE__*/_react.default.createElement(Component, rest));
  };

  return /*#__PURE__*/(0, _react.memo)(ComponentWithContext);
};

exports.withContext = withContext;